import React from 'react';
import CountryFlag from 'components/CountryFlag/CountryFlag';
import { TLanguageIDs } from 'types';
import { availableCountries } from 'appConstants';
import classNames from 'classnames';
import style from './LanguageBarItem.module.scss';

interface ILanguageBarItem {
	onClick: () => void;
	languageId: TLanguageIDs;
	isActive: boolean;
	isDefault?: boolean;
	itemHasError?: boolean;
}

const LanguageBarItem: React.FC<ILanguageBarItem> = ({ onClick, languageId, isActive, isDefault, itemHasError }) => {
	const containerClasses = classNames(style.container, { [style.active]: isActive, [style.hasError]: itemHasError });

	const { countryCode, languageName } = availableCountries[languageId];

	return (
		<div className={containerClasses} onClick={onClick} data-test={`LanguageBarItem-${languageName}`}>
			<CountryFlag countryCode={countryCode} size="24px" />
			<div className={style.label}>
				{languageName}
				{isDefault && <span> (Default)</span>}
			</div>
		</div>
	);
};

export default React.memo(LanguageBarItem);
